export const BTN_MORE_CLASSNAME = 'admin-tabs-button-more'
export const RING_TABS_CLASSNAME = 'ring-tabs-rendered'

export const HINTS_REGISTRATION_DELAY = 500
